import styled from 'styled-components/native';

export const Container = styled.View`
  background: ${props => props.theme.colors.grayscale.slot2};
  height: 4px;
  border-radius: 10px;
`;

export const Bar = styled.View`
  position: absolute;
  top: 0px;
  left: 0px;
  width: ${props => props.value}%;
  height: 100%;
  border-radius: 10px;
  background: ${props => props.color};
`;
